import React, {useEffect} from 'react';
import {Button, Form} from "antd";
import useActions from "../../../hooks/useActions";
import {useSelector} from "react-redux";
import ProductImage from "./ProductImage/ProductImage";
const ProductImages = ({initialFeaturedImageValue = null, initialGalleryImageValues = [], isCategory, formRef, setIsChanged = () => {}}) => {

    const {
        setProductImagePopupVisible,
        setIsFeaturedImage, getImagesByIds, setIsFeaturedImageUploaded, setIsGalleryImagesUploaded} = useActions();
    const {featuredImage, galleryImages, featuredId, isFeaturedImageUploaded, isGalleryImagesUploaded} = useSelector(state => state?.productImages)

    const fallback = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==';

    useEffect(() => {
        if (initialFeaturedImageValue) {
            getImagesByIds( {
                params: { ids: initialFeaturedImageValue,}, isFeatured: true })
        }

        if (!isCategory && initialGalleryImageValues.length > 0) {
            getImagesByIds( {
                params: {
                    ids: [...new Set(initialGalleryImageValues.map(val => val.id))]
                }, isFeatured: false
            })
        }

    }, []);

    const setValuesByType = (type, values, setImageUploaded) => {
        formRef.current.setFieldsValue({
            [type]: values
        })
        setIsChanged(true)
        setProductImagePopupVisible(false)
        setImageUploaded(false)
    }

    useEffect(() => {
        if (featuredId && formRef.current && isFeaturedImageUploaded){
            setValuesByType('featured_image', featuredId, setIsFeaturedImageUploaded)
        }

        if (!isCategory && galleryImages.length > 0 && formRef.current && isGalleryImagesUploaded){
            setValuesByType('images', galleryImages.map(img => img.id), setIsGalleryImagesUploaded)
        }
    }, [formRef, isFeaturedImageUploaded, isGalleryImagesUploaded])

    const changeImageClickHandler = () => {
        setIsFeaturedImage(true)
        setProductImagePopupVisible(true)
    }

    const addNewGalleryImage = () => {
        setIsFeaturedImage(false)
        setProductImagePopupVisible(true)
    }

    return (
        <div className='product-image__wrapper'>
            <Form.Item labelCol={{span: 4}} label='Utvald bild'>
                <ProductImage formRef={formRef}
                              isOne={true}
                              setIsChanged={setIsChanged}
                              url={featuredImage}
                              fallback={fallback}/>
                <Button style={{marginTop: '10px'}} onClick={changeImageClickHandler}>{featuredImage ? 'Byt utvald bild' : 'Lägg till utvald bild'}</Button>
            </Form.Item>
            {
                !isCategory &&
                <Form.Item labelCol={{span: 4}} label='Bildgalleri'>
                    {
                        galleryImages.length > 0 &&
                        <div className='product-gallery'>
                            {
                                galleryImages.map(image => (
                                    <ProductImage key={image.id} id={image.id}
                                                  url={image.url} fallback={fallback}
                                                  width='80px'
                                                  height='80px'
                                                  setIsChanged={setIsChanged}
                                                  formRef={formRef}
                                                  initialGalleryImageValues={initialGalleryImageValues}
                                    />
                                ))
                            }
                        </div>
                    }
                    <Button style={{marginBottom: '20px'}}
                            onClick={addNewGalleryImage}>
                        {galleryImages.length > 0 ? 'Lägg till bild till bildgalleri' : 'Välj bild(er)'}
                    </Button>
                </Form.Item>
            }

        </div>
    );
};

export default ProductImages;
